import React, { Component } from "react";
import { listVehicleTypes, getVehicle } from "../../graphql/queries";
import gql from "graphql-tag";
import { spinnerService } from "@chevtek/react-spinners";
import withStyles from "@material-ui/core/styles/withStyles";

import Select from "react-select";
import {
  Button,
  FormGroup,
  Form,
  Input,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

import { connect } from "react-redux";

import { toast } from "react-toastify";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import { styles } from '../../assets/css/styles';
class CustVehicleDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typeName: "",
      createdAt: "",
      customerVehicleId: "",
      Id: "",
      license: "",
      locationLat: "",
      locationLong: "",
      make: "",
      model: "",
      updatedAt: "",
      vehicleCustomerId: "",
      vehicleYear: "",
      vIN: "",
      selectedOptions: []
    };
  }

  onTextChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };
  notify = msg => toast(msg);

  cancelForm = e => {
    //this.props.location.loadData();
    this.props.history.push("../../customer");
  };
  loadVehicle = async id => {
    spinnerService.show("mySpinner");

    const { client } = this.props;
    const vehicle = await client.query({
      query: gql(getVehicle),
      fetchPolicy: `network-only`,
      variables: { id }
    });
    let typeName = {};
    if (vehicle.data.getVehicle.vehicleType !== null) {
      typeName = {
        label: vehicle.data.getVehicle.vehicleType.vehicleType,
        value: vehicle.data.getVehicle.id
      };
    }
    this.setState({
      typeName,
      customerVehicleId: vehicle.data.getVehicle.customerVehicleId,
      Id: vehicle.data.getVehicle.id,
      license: vehicle.data.getVehicle.license,
      make: vehicle.data.getVehicle.make,
      model: vehicle.data.getVehicle.model,
      updatedAt: "",
      vehicleYear: vehicle.data.getVehicle.vehicleYear,
      vIN: vehicle.data.getVehicle.VIN,
      specialInstructions: vehicle.data.getVehicle.specialInstructions
    });
    spinnerService.hide("mySpinner");
  };
  async componentDidMount() {
    if (this.props.data === undefined || this.props.data.length == 0) {
      await this.loadVehicle(this.props.match.params.id);
    } else {
      this.fetchFromStore(this.props.match.params.id);
      await true;
    }
  }

  fetchFromStore = id => {
    this.props.data.vehiclesList.map(Item => {
      if (Item.id === id) {
        var typeName = null;
        if (Item.vehicleType !== undefined && Item.vehicleType !== null) {
          typeName = {
            label: Item.vehicleType.vehicleType,
            value: Item.vehicleType.id
          };
        }

        this.setState({
          typeName,
          customerVehicleId: Item.customerVehicleId,
          Id: Item.id,
          license: Item.license,
          make: Item.make,
          model: Item.model,
          updatedAt: "",
          vehicleYear: Item.vehicleYear,
          vIN: Item.VIN,
          specialInstructions: Item.specialInstructions
        });
      }
    });
  };
  handleChange = typeName => {
    this.setState({ typeName });
  };
  render() {
    const { classes } = this.props;
    return (
      <div>
        <main ref="main" App>
          <section className="section section-shaped section-lg">
            <Container className="pt-lg-sm pt-2">
              <Row className="justify-content-center">
                <Col lg={10}>
                  <Card>
                    <CardHeader color="primary">
                      <h4 className={classes.cardTitleWhite}>
                        Vehicle Details
                      </h4>
                      <p className={classes.cardCategoryWhite}>
                        See Information Below
                      </p>
                    </CardHeader>
                    <CardBody
                      style={{ backgroundColor: "White" }}
                      className="px-5 py-5"
                    >
                      <Form role="form">
                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <div>CustomerVehicle ID</div>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="customerVehicleId"
                                  onChange={this.onTextChange.bind(this)}
                                  disabled
                                  type="text"
                                  value={this.state.customerVehicleId}
                                  required
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <div>Calbit ID</div>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="Id"
                                  onChange={this.onTextChange}
                                  disabled
                                  type="text"
                                  value={this.state.Id}
                                  required
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <div>Vehicle Type</div>
                              <Input
                                value={this.state.typeName.label}
                                id="typeName"
                                onChange={this.handleChange}
                                disabled
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <div>VIN</div>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="vIN"
                                  onChange={this.onTextChange}
                                  type="text"
                                  value={this.state.vIN}
                                  required
                                  disabled
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <div>Make</div>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="make"
                                  onChange={this.onTextChange}
                                  type="text"
                                  value={this.state.make}
                                  disabled
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <div>Model</div>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  disabled
                                  id="model"
                                  type="text"
                                  value={this.state.model}
                                  onChange={this.onTextChange}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <div>License</div>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="license"
                                  onChange={this.onTextChange}
                                  type="text"
                                  value={this.state.license}
                                  disabled
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <div>Vehicle Year</div>{" "}
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  disabled
                                  id="vehicleYear"
                                  type="text"
                                  onChange={this.onTextChange}
                                  value={this.state.vehicleYear}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row form>
                          <Col>
                            <FormGroup>
                              <div>Special Instructions</div>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="specialInstructions"
                                  onChange={this.onTextChange}
                                  type="text"
                                  value={this.state.specialInstructions}
                                  disabled
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>

                        <div className="text-center">
                          <Row lg="12" className="px-3 ">
                            <Col></Col>
                            <Col>
                              <Button
                                className=" btn-lg btn-block mt-2"
                                color="default"
                                onClick={this.cancelForm}
                              >
                                Back
                              </Button>
                            </Col>
                            <Col></Col>
                          </Row>
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    loading: state.adminCustomer.loading,
    data: state.adminCustomer.data
  };
};
export default CustVehicleDetails = connect(
  mapStateToProps,
  null
)(withStyles(styles)(CustVehicleDetails));



// WEBPACK FOOTER //
// ./src/admin/customer/CustVehicleDetails.jsx